
import { defineComponent } from "vue";
import { Queuer } from "@/types/Donor";

export default defineComponent({
  name: "DonationQueue",
  data() {
    return {
      filterBy: "Priority Number",
      sortBy: "Ascending",
    };
  },
  props: {
    windowWidth: {
      type: Number,
      required: true,
    },
    queuers: {
      type: Array as () => Queuer[],
      required: true,
    },
  },
  methods: {
    setFilterBy(filterBy: string) {
      this.filterBy = filterBy;

      switch (filterBy) {
        case "Name":
          this.filteredQueue.sort((a, b) => {
            return this.sortBy === "Ascending"
              ? a.name.localeCompare(b.name)
              : b.name.localeCompare(a.name);
          });
          break;
        case "Queue Time":
          this.filteredQueue.sort((a, b) => {
            return this.sortBy === "Ascending"
              ? new Date(a.createdAt).getTime() -
                  new Date(b.createdAt).getTime()
              : new Date(b.createdAt).getTime() -
                  new Date(a.createdAt).getTime();
          });
          break;
        case "Distance":
          this.filteredQueue.sort((a, b) => {
            return this.sortBy === "Ascending"
              ? a.distance - b.distance
              : b.distance - a.distance;
          });
          break;
        case "Donations Received":
          this.filteredQueue.sort((a, b) => {
            return this.sortBy === "Ascending"
              ? a.donationsReceived - b.donationsReceived
              : b.donationsReceived - a.donationsReceived;
          });
          break;
        case "Priority Number":
        default:
          this.filteredQueue.sort((a, b) => {
            return this.sortBy === "Ascending"
              ? a.queuePos - b.queuePos
              : b.queuePos - a.queuePos;
          });
          break;
      }
    },
    setSortBy(sortBy: string) {
      this.sortBy = sortBy;
      this.setFilterBy(this.filterBy);
    },
    truncateText(text: string) {
      const truncated = text.length > 6 ? text.substring(0, 6) + "..." : text;
      return this.windowWidth > 576 ? text : truncated;
    },
    getOrdinalSuffix(number: number) {
      const suffix = ["th", "st", "nd", "rd"],
        v = number % 100;
      return number + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
    },
    getTime(dateString: string) {
      const date = new Date(dateString);
      const hours = date.getHours() % 12;
      const minutes =
        date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      const meridiem = date.getHours() < 12 ? "AM" : "PM";
      return `${hours}:${minutes} ${meridiem}`;
    },
    confirmQueuer(queuer: Queuer) {
      console.log("Confirmed transaction with", queuer.name);
    },
    declineQueuer(queuer: Queuer) {
      console.log("Declined transaction with", queuer.name);
    },
  },
  computed: {
    filteredQueue(): Queuer[] {
      return this.queuers.map((queuer) => {
        return {
          ...queuer,
        };
      });
    },
  },
});
